import React, { useEffect, useState } from 'react';
import { BaseSelector } from '../../../../models/baseSelector';
import { WorkshiftsAPI } from '../../../../services/external/APIs';
import AsyncSelect from 'react-select/async';
import { WorkshiftLongWorkshift } from '../../../../models/workshifts/workshiftLongWorkshifts';

interface Props {
    compensationDate: string;
    name: string;
    disable?: boolean;
    onChange: (name: string, value: string | null | number | undefined) => void;
    value: string | undefined | number;
}

export const WorkshiftsLongShiftSelector = ({
    name,
    compensationDate,
    onChange,
    disable = false,
    value,
}: Props) => {
    const [dataList, setDataList] = useState<BaseSelector[]>([]);
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        WorkshiftsAPI.getLongTypes(compensationDate)
            .then((res: WorkshiftLongWorkshift[]) => {
                const convertedResponse = res.map((item) => {
                    return {
                        label: item.workshiftName,
                        value: item.workshiftId,
                    };
                });
                setDataList(convertedResponse);
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }, [compensationDate]);

    const filterName = (inputValue: string) => {
        return dataList.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const loadOptions = (
        inputValue: string,
        callback: (options: BaseSelector[]) => void
    ) => {
        setTimeout(() => {
            callback(filterName(inputValue));
        }, 1000);
    };

    return (
        <AsyncSelect
            isLoading={isLoadingData}
            onChange={(e) => {
                onChange(name, e?.value);
            }}
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions={dataList}
            name='destiny-selector'
            isClearable
            placeholder={`Seleccione...`}
            className='flex-1'
            isDisabled={disable}
            value={
                dataList.find((a) => a.value === value) ?? {
                    label: `Seleccione...`,
                    value: 0,
                }
            }
        />
    );
};
